<div class="searchbox-card search-form">
  <mat-tab-group>
    <mat-tab label="Profili Professionali" >

      <atlante-profili-competenze />

    </mat-tab>


    <mat-tab label="Competenze">

      <atlante-competenze />

    </mat-tab>

  </mat-tab-group>

</div>
